// 支付进件提示
import { Module } from 'vuex';
import RootState from '../../state';

export const bindingStateMerchantType = 1;
export const bindingStateDistributionType = 2;
interface IPayBindingState {
    errMsg: any;
    bindingState: boolean;
    type: number;
    code: number;
}

// type: 1商家，type: 2 分销者
const intialState = {
    errMsg: '',
    bindingState: true,
    type: 0,
    code: 0,
};

const PayBindingStore: Module<IPayBindingState, RootState> = {
    namespaced: true,
    state: intialState,
    mutations: {
        // 内部action及外部直接调用，创建时
        update(state: typeof intialState, { bindingState, errMsg = '', type, code }) {
            state.errMsg = errMsg;
            state.bindingState = bindingState;
            state.type = type;
            state.code = code;
        },
    },
    actions: {
        async checkHighRisk({ commit }, { dealDataFn, serviceFn, params }) {
            if (typeof serviceFn === 'function') {
                let { data } = await serviceFn(params);
                data = typeof serviceFn === 'function' ? dealDataFn(data) : data;
                commit('update', data);
            }
        },
    },
};

export default PayBindingStore;
